import { IPartnerPdf, PartnerPdf } from "@/models/partner-pdf.entity";
import { BackwardsCompatibleDataAccessLayer } from "@/store/backwards-compatible-paginated.store";

export const PartnerPdfDataAccessLayer = new (class extends BackwardsCompatibleDataAccessLayer<IPartnerPdf> {
  protected mapEntity(entity: IPartnerPdf): IPartnerPdf {
    return new PartnerPdf(entity);
  }
})();
